import { toastr } from 'react-redux-toastr';
import { KIDS_ON_ITINERARY_ENDPOINT, KIDS_ON_ITINERARY_RESERVATION_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_KIDS_ON_ITINERARY,
  FLAG_KIDS_ON_ITINERARY_ACTIVITY,
  GET_KIDS_ON_ITINERARY,
} from '../types';
import { KID_ASSIGNED_INFO_MESSAGE } from '../../config/messages';

const flagKidsOnItineraryActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_KIDS_ON_ITINERARY_ACTIVITY,
    payload: flag,
  });

const getKidsOnItinerary =
  async ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagKidsOnItineraryActivity(true));

      const url = `${KIDS_ON_ITINERARY_ENDPOINT}/${itineraryId}`;

      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });

      await isErrorResponse(response, null, dispatch);

      const itinerary = await response.json();

      dispatch({ type: GET_KIDS_ON_ITINERARY, payload: itinerary });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagKidsOnItineraryActivity(false));
    }
  };

const clearKidsOnItinerary = () => (dispatch) =>
  dispatch({
    type: CLEAR_KIDS_ON_ITINERARY,
  });

const postKidsOnItineraryRequest = async ({
  itineraryId,
  seatNumber,
  floorNumber,
  parentCustomerId,
  kidCustomerId,
  relationship,
  comments,
}) => {
  const payload = {
    itineraryId,
    seatNumber,
    floorNumber,
    parentCustomerId,
    kidCustomerId,
    relationship,
    comments,
  };

  const response = await fetch(KIDS_ON_ITINERARY_ENDPOINT, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });

  await isErrorResponse(response);

  const kidOnItinerary = await response.json();

  return kidOnItinerary;
};

const postKidsOnItineraryRequestV2 = async ({
  itineraryId,
  parentCustomerId,
  kidCustomerId,
  relationship,
  comments,
  kidWithSeatAssigned,
  notarizedPermit,
}) => {
  const payload = {
    itineraryId,
    parentCustomerId,
    kidCustomerId,
    relationship,
    comments,
    kidWithSeatAssigned,
    notarizedPermit,
  };

  const response = await fetch(KIDS_ON_ITINERARY_ENDPOINT, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });

  await isErrorResponse(response);

  const kidOnItinerary = await response.json();

  return kidOnItinerary;
};

const postKidsOnItineraryReservationRequest = async ({
  itineraryId,
  seatNumber,
  floorNumber,
  parentCustomerId,
  kidCustomerId,
  relationship,
  comments,
  kidSeatNumber,
  kidFloorNumber,
  notarizedPermit,
  kidDto,
}) => {
  const payload = {
    itineraryId,
    seatNumber,
    floorNumber,
    parentCustomerId,
    kidCustomerId,
    relationship,
    comments,
    kidSeatNumber,
    kidFloorNumber,
    notarizedPermit,
    kidDto,
  };

  const response = await fetch(KIDS_ON_ITINERARY_RESERVATION_ENDPOINT, {
    ...DEFAULT_POST_CONFIG,
    body: JSON.stringify(payload),
  });

  await isErrorResponse(response);

  const kidsOnItinerary = await response.json();

  return kidsOnItinerary;
};

const postKidsOnItinerary =
  async (payload, getKids = false, clearForm = null) =>
  async (dispatch) => {
    try {
      dispatch(flagKidsOnItineraryActivity(true));

      const response = await postKidsOnItineraryRequestV2(payload);

      if (getKids) {
        await dispatch(
          getKidsOnItinerary({ itineraryId: payload.itineraryId }),
        );
      }

      toastr.success('Éxito', KID_ASSIGNED_INFO_MESSAGE);
      
      if (clearForm) {
        clearForm();
      }
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
      return null;
    } finally {
      dispatch(flagKidsOnItineraryActivity(false));
    }
  };

const deleteKidsOnItineraryRequest = async ({ id }) => {
  const url = `${KIDS_ON_ITINERARY_ENDPOINT}/${id}`;

  const response = await fetch(url, {
    ...DEFAULT_DELETE_CONFIG,
  });

  await isErrorResponse(response);

  const kidOnItinerary = await response.json();

  return kidOnItinerary;
};

const deleteKidsOnItinerary =
  async (id, itineraryId = null) =>
  async (dispatch) => {
    try {
      dispatch(flagKidsOnItineraryActivity(true));

      const response = await deleteKidsOnItineraryRequest(id);

      if (itineraryId) {
        await dispatch(getKidsOnItinerary({ itineraryId }));
      }

      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
      return null;
    } finally {
      dispatch(flagKidsOnItineraryActivity(false));
    }
  };

export {
  flagKidsOnItineraryActivity,
  getKidsOnItinerary,
  clearKidsOnItinerary,
  deleteKidsOnItinerary,
  postKidsOnItinerary,
  postKidsOnItineraryRequest,
  postKidsOnItineraryRequestV2,
  postKidsOnItineraryReservationRequest,
  deleteKidsOnItineraryRequest,
};
